export default __webpack_public_path__ + "static/media/modern-eng.ba2fdd22.png";